import { css } from 'styled-components';
import { Breakpoints, commonBreakpointsValues } from '@lmn/design-tokens/themeTokens/commonBreakpoints';
import { isTouchDevice } from "../../utils/useIsTouchDevice.js";
export var onlyForNonTouchDevices = function onlyForNonTouchDevices(styles) {
  return !isTouchDevice() ? css(["", ""], styles) : css([""]);
};
export var onlyForTouchDevices = function onlyForTouchDevices(styles) {
  return isTouchDevice() ? css(["", ""], styles) : css([""]);
};
export var higherOrEqualThanBreakpoint = function higherOrEqualThanBreakpoint(breakpoint, styles) {
  return css(["@media (min-width:", "px){", "}"], commonBreakpointsValues[breakpoint], styles);
};
export var lowerThanBreakpoint = function lowerThanBreakpoint(breakpoint, styles) {
  return css(["@media (max-width:", "px){", "}"], commonBreakpointsValues[breakpoint] - 1, styles);
};
export var onlyForTabletAndLower = function onlyForTabletAndLower(styles) {
  return lowerThanBreakpoint(Breakpoints['breakpoints-m'], styles);
};
export var onlyForDesktopAndHigher = function onlyForDesktopAndHigher(styles) {
  return higherOrEqualThanBreakpoint(Breakpoints['breakpoints-m'], styles);
};